import React from "react";
import ReactPaginate from "react-paginate";

const Pagination = ({
  pageCount,
  handlePageChange,
  pageNumber,
  paginationcontrol,
  activeClass,
}) => {
  const safePageCount = Number.isFinite(pageCount) ? Math.max(pageCount, 0) : 0;
  const safePageNumber = Number.isFinite(pageNumber) ? Math.max(pageNumber, 0) : 0;
  const currentPage = safePageCount === 0 ? 0 : Math.min(safePageNumber + 1, safePageCount);

  return (
    <div className={`gm-pagination ${paginationcontrol || ""}`.trim()}>
      <span className="gm-pagination__summary" aria-live="polite">
        Page {currentPage} of {safePageCount}
      </span>

      {safePageCount > 0 && (
        <ReactPaginate
          previousLabel="Prev"
          nextLabel="Next"
          pageCount={safePageCount}
          onPageChange={handlePageChange}
          containerClassName="paginationBtns"
          previousLinkClassName="previousBtn"
          nextLinkClassName="nextBtn"
          disabledClassName="paginationDisabled"
          pageRangeDisplayed={5}
          marginPagesDisplayed={1}
          activeClassName="paginationActive"
          forcePage={Math.min(safePageNumber, safePageCount - 1)}
          breakLabel="…"
        />
      )}
    </div>
  );
};

export default Pagination;

// import React from 'react';
// import ReactPaginate from 'react-paginate';

// const Pagination = ({pageCount,handlePageChange,pageNumber,paginationcontrol,activeClass}) => {
//   return (
//     <div className="paginationContainer" 
//     style={{ position: "absolute",left:100,width:"100%"}} >
//           <div style={{backgroundColor:"green"}}>
//           <ReactPaginate
//             previousLabel={"Prev"}
//             nextLabel={"Next"}
//             pageCount={pageCount}
//             onPageChange={handlePageChange}
//             containerClassName={"paginationBtns"}
//             previousLinkClassName={"previousBtn"}
//             nextLinkClassName={"nextBtn"}
//             disabledClassName={"paginationDisabled"}
//             pageRangeDisplayed={5}
//             activeClassName={"paginationActive"}
//             forcePage={pageNumber}
//             // activeClassName={activeClass}
//             />
//           </div>
//             <pre style={{fontSize:"13px",position:"absolute",left:"180px"}} >{pageNumber+1} of {pageCount} Pages</pre>
//     </div>
//   )
// }


// export default Pagination
